var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPlus(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.875 12.5C21.875 12.7072 21.7927 12.9059 21.6462 13.0524C21.4997 13.1989 21.301 13.2812 21.0938 13.2812H13.2812V21.0938C13.2812 21.301 13.1989 21.4997 13.0524 21.6462C12.9059 21.7927 12.7072 21.875 12.5 21.875C12.2928 21.875 12.0941 21.7927 11.9476 21.6462C11.8011 21.4997 11.7188 21.301 11.7188 21.0938V13.2812H3.90625C3.69905 13.2812 3.50034 13.1989 3.35382 13.0524C3.20731 12.9059 3.125 12.7072 3.125 12.5C3.125 12.2928 3.20731 12.0941 3.35382 11.9476C3.50034 11.8011 3.69905 11.7188 3.90625 11.7188H11.7188V3.90625C11.7188 3.69905 11.8011 3.50034 11.9476 3.35382C12.0941 3.20731 12.2928 3.125 12.5 3.125C12.7072 3.125 12.9059 3.20731 13.0524 3.35382C13.1989 3.50034 13.2812 3.69905 13.2812 3.90625V11.7188H21.0938C21.301 11.7188 21.4997 11.8011 21.6462 11.9476C21.7927 12.0941 21.875 12.2928 21.875 12.5Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlus);
export default __webpack_public_path__ + "static/media/Plus.8232622642a8c680517bc5f459ed6998.svg";
export { ForwardRef as ReactComponent };